// src/components/Sidebar/SidebarFooter.jsx
import React from "react";
import ButtonWithIcon from "../ButtonwithIcon/ButtonWithIcon";

export default function SidebarFooter({ collapsed, onCreateProject }) {
  return (
    <div className="Sidebar-sidebar-bottom">
      <ButtonWithIcon
        color="success"
        iconPosition="left"
        className="button-with-icon success"
        onClick={onCreateProject}
        text={collapsed ? "" : "Project"}
        icon="mdi:plus"
      />
    </div>
  );
}
